// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2tcbP","hide":"styles_hide__B7SYD","content":"styles_content__375N5","soundIcon":"styles_soundIcon__R39zx"};